import React, { useEffect, useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FormLayout from "../components/layout/FormLayout";
import RegistrationContext from "../context/registration/registrationContext";
import AdminInterestContext from "../context/adminInterest/adminInterestContext";
import RegistrationForInterest from "../components/RegistrationForm/RegistrationForInterest";
import queryString from "query-string";
import l4lLogo from "../img/l4l.png";
import llacLogo from "../img/llac-logo.png";
import Flexhighlogo from "../img/Flexhighlogo.png";
import stanzalogo from "../img/stanzalogo.png";
import elev8logo from "../img/elev8logo.png";
import holstonlogo from "../img/holstonlogo.png";
import pbialogo from "../img/PBIA.png";
import { brandDomains, fetchBrands } from "../components/brand";

const RegistrationFormPageInt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const registrationContext = useContext(RegistrationContext);
    const adminInterestContext = useContext(AdminInterestContext);
    const [currentUuid, setCurrentUuid] = useState(null);
    const [apiLearningCenterData, setApiLearningCenterData] = useState(null);
    const [isLoadingApiData, setIsLoadingApiData] = useState(false);
    const [brandsLoaded, setBrandsLoaded] = useState(false);

    const {
        formData,
        onFormDataChange,
    } = registrationContext;

    const { getEntriebyuuid } = adminInterestContext;

    const { getSiteprogram, charterPreSelected, Siteprogram } =
        registrationContext;
    
    // Use API data if available, otherwise fall back to Siteprogram data
    const learningCenterCharter = apiLearningCenterData?.learningCenterCharter || 
                                 (Siteprogram.charter && Siteprogram.charter.name) || 
                                 formData.learningCenterCharter;
    // Get brand icon and name from saved API data

    const brandName = apiLearningCenterData?.brandName;
   
    console.log("brandName from saved record:", brandName);
  
    
    const learningCenterName = apiLearningCenterData?.learningCenterName || 
                              Siteprogram.name || 
                              formData.learningCenterName;

    // Update formData with the resolved values
    formData.learningCenterCharter = learningCenterCharter;
    formData.learningCenterName = learningCenterName;
   

    //console.log("formData.learningCenterCharter", formData.learningCenterCharter);
    //console.log("formData.learningCenterName", formData.learningCenterName);

    useEffect(() => {
        const loadBrands = async () => {
            try {
                await fetchBrands();
                setBrandsLoaded(true);
              //  console.log("Brands loaded:", brandDomains);
            } catch (error) {
                console.error("Error loading brands:", error);
                setBrandsLoaded(true); // Set to true anyway to prevent infinite loading
            }
        };
        loadBrands();
    }, []);


    
    // Get the appropriate brand photo based on brandName from saved record
    const getBrandPhoto = () => {
        if (!brandsLoaded || !brandName) {
            return null; // Return null to show loading instead of default logo
        }

        // Find matching brand in brandDomains based on brandName from API
        const brandEntry = Object.values(brandDomains).find(
            brand => brand?.name === brandName
        );

        // Return brandPhoto from brandDomains, or fallback to static images
        if (brandEntry?.brandPhoto) {
            return brandEntry.brandPhoto;
        }

        // Fallback to static images based on brand name
        switch (brandName) {
            case "Holston":
                return holstonlogo;
            case "Elev8":
                return elev8logo;
            case "Stanza":
                return stanzalogo;
            case "LLAC":
                return llacLogo;
            case "Flex High":
                return Flexhighlogo;
            case "Learn4Life":
                return l4lLogo;
            case "Palm Beach International":
                return pbialogo;
            default:
                return (Siteprogram.charter && Siteprogram.charter.brand.brandPhoto) || llacLogo;
        }
    };

    const brandPhoto = getBrandPhoto();
  
   
    // Function to fetch API data based on UUID
    const fetchApiData = async (uuid) => {
        if (!uuid) return;
        
        setIsLoadingApiData(true);
        try {
            console.log("Fetching API data for UUID:", uuid);
            const response = await getEntriebyuuid(uuid);
            console.log("API Response:", response.data);
           
            
            if (response && response.data) {
                const data = response.data;
                //console.log("Extracted API data:", data);
                
                // Extract learning center information from API response
                const apiData = {
                    learningCenterName: data.learningCenterName || "Antelope Valley Learning Academy",
                    learningCenterCharter: data.learningCenterCharter || data.charter || "",
                    learningCenterAddress: data.learningCenterAddress || "",
                    brandName:data.brandName||"",
                };
                
                setApiLearningCenterData(apiData);
                
                // Update form data with API values
                Object.keys(apiData).forEach(key => {
                    if (apiData[key]) {
                        onFormDataChange({ target: { name: key, value: apiData[key] } });
                    }
                });
           
                
               // console.log("Updated learning center data from API:", apiData);
            } else if (response && typeof response === 'object' && !response.data) {
                // Handle case where response doesn't have data property
                const apiData = {
                    learningCenterName: response.learningCenterName || "Antelope Valley Learning Academy",
                    learningCenterCharter: response.learningCenterCharter || response.charter || "",
                    learningCenterAddress: response.learningCenterAddress || "",
                    brandName:data.brandName||"",
                };
                
                setApiLearningCenterData(apiData);
                
                Object.keys(apiData).forEach(key => {
                    if (apiData[key]) {
                        onFormDataChange({ target: { name: key, value: apiData[key] } });
                    }
                });
       
            }
        } catch (error) {
            console.error("Error fetching API data:", error);
            // Set default values if API call fails
            setApiLearningCenterData({
                learningCenterName: "Antelope Valley Learning Academy",
                learningCenterCharter: "",
                learningCenterAddress: "",
            });
        } finally {
            setIsLoadingApiData(false);
        }
    };

    useEffect(() => {
        var query = queryString.parse(location.search);
        getSiteprogram(query.site);

        if (query.uuid) {
            setCurrentUuid(query.uuid);
            // Fetch API data when UUID is available
            fetchApiData(query.uuid);
        }

        // Extract uuid from current URL and include it in the redirect
        const uuid = query.uuid;
        if (uuid) {
            navigate(`/register-interest?uuid=${uuid}`);
        } else {
            navigate("/");
        }
        
        if (query.charter) {
            charterPreSelected(query.charter);
        }
    }, []);

    return (
        <FormLayout>
           <div className="brand-header">
                <div className="text-center" style={{ marginTop: "10px" }}>
                    {brandPhoto ? (
                        <Link to="/">
                            <img
                                src={brandPhoto}
                                alt="Brand Logo"
                                className="branding-logo"
                                height={"69px"}
                            />
                        </Link>
                    ) : (
                        <p style={{ fontSize: "16px", color: "#666" }}>Loading...</p>
                    )}
                </div>
            </div>
            <div className="intro-box">
                {isLoadingApiData ? (
                    <p className="text-center" style={{ fontSize: "20px", padding: "0em 2em" }}>
                        Loading your information...
                    </p>
                ) : (
                    <p className="text-center" style={{ fontSize: "20px", padding: "0em 2em" }}>
                        Thank you for enrolling and choosing to be a part of{" "}
                        {learningCenterCharter && learningCenterName ? 
                            `${learningCenterCharter} - ${learningCenterName}` : 
                            learningCenterName || "our educational community"
                        }. We are
                        thrilled to welcome you to our educational community! Your decision to
                        join us marks the beginning of an exciting journey filled with growth,
                        discovery, and new experiences. We look forward to supporting you as
                        you pursue your academic and personal goals.
                    </p>
                )}
            </div>

            <RegistrationForInterest uuid={currentUuid} />
        </FormLayout>
    );
};

export default RegistrationFormPageInt;